/* eslint-disable */
import { Length } from ".//length";
import { PayloadType } from ".//payload-type";
import { QuantityView } from ".//quantity-view";
import { Weight } from ".//weight";

export class PayloadItemView {

    shipmentLineId: number | undefined;
    currencyCode: string | undefined;
    itemBreadth: number | undefined;
    itemDesciption: string | undefined;
    itemDescription?: string;
    itemHeight: number | undefined;
    itemLength: number | undefined;
    itemQuantity: QuantityView | undefined;
    tenantUomId?: number;
    tenantUomName?: string;
    enteredQuantity?: number;
    factorToBase?: number;
    itemType: PayloadType | undefined;
    itemWeight: number | undefined;
    lengthUnit: Length | undefined;
    packingListIndex: number;
    price: number | undefined;
    receivingQuantity: QuantityView | undefined;
    shippingQuantity: QuantityView | undefined;
    weightUnit: Weight | undefined;
    transportReleaseId?: number;
    transportReleaseNumber?: string;
    transportReleaseLineId?: number;
    crossDockOrchestrationId?: number;
    crossDockOrchestrationNumber?: string;
    crossDockLegSequence?: number;
    crossDockLegType?: string;
    lineSource?: 'GENERAL_CARGO' | 'WAREHOUSE_ITEM' | 'CONTAINER';
    inventoryItemId?: number;
    warehouseItemNumber?: string;
    skuNumber?: string;
    customerItemNumber?: string;
    warehouseItemName?: string;
    trackingMode?: string;
    itemSize?: string;
    sourceRegionId?: number;
    sourceWarehouseId?: number;
    sourceWarehouseLabel?: string;
    sourceZoneId?: number;
    sourceZoneLabel?: string;
    conditionId?: number;
    conditionLabel?: string;
    linkedWarehouseTransferId?: number;
    linkedWarehouseTransferNumber?: string;
    linkedWarehouseDispatchId?: number;
    linkedWarehouseDispatchNumber?: string;
    containerNumber?: string;
    isoEquipmentType?: string;
    sealNumber?: string;
    bookingNumber?: string;
    billOfLadingNumber?: string;
    houseBillNumber?: string;
    customsDeclarationNumber?: string;
    journeyTemplateId?: number;

}
